import type { Filters, Project, RiskBucket } from "./types";

export function riskBucket(project: Project): RiskBucket {
  if (project.hardStop || project.rating === "D") return "stop";
  if (project.rating === "C" || project.riskScore > 40) return "watch";
  return "research";
}

export function sortByPriority(projects: Project[]): Project[] {
  return [...projects].sort((a, b) => b.priorityScore - a.priorityScore);
}

export function filterProjects(projects: Project[], filters: Filters): Project[] {
  const query = filters.query.trim().toLocaleLowerCase("zh-CN");
  return sortByPriority(projects.filter((project) => {
    const haystack = [project.name, project.sector, project.network, project.type]
      .join(" ").toLocaleLowerCase("zh-CN");
    return (!query || haystack.includes(query))
      && (filters.rating === "all" || project.rating === filters.rating)
      && (filters.risk === "all" || riskBucket(project) === filters.risk);
  }));
}
